import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ChatsSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.61489 19.1686C6.9464 19.1686 7.17815 19.052 7.57021 18.7067L10.5096 16.0351L9.82516 15.296L6.86957 18.0534V15.9849C6.86957 15.6283 6.65254 15.4586 6.3775 15.4586H5.0455C3.75388 15.4586 3.0105 14.7632 3.0105 13.4145V7.01501C3.0105 5.66627 3.75669 4.95837 5.0455 4.95837H14.9578C16.2529 4.95837 16.9991 5.66627 16.9991 7.01501V8.07361H18.0096V6.96173C18.0096 5.09046 16.9103 4.01624 15.0362 4.01624H4.9734C3.15925 4.01624 2 5.09046 2 6.96173V13.4552C2 15.3356 3.15925 16.407 4.9734 16.407H5.91554V18.389C5.91554 18.8782 6.16548 19.1686 6.61489 19.1686ZM18.178 19.9838C18.6064 19.9838 18.8514 19.6795 18.8514 19.2078V17.4985H19.2026C20.8973 17.4985 22 16.4897 22 14.729V10.4027C22 8.64832 20.8973 7.63673 19.2026 7.63673H12.196C10.4388 7.63673 9.40209 8.64832 9.40209 10.4027V14.7347C9.40209 16.4954 10.4388 17.4985 12.196 17.4985H14.9552L17.2926 19.4982C17.6665 19.8191 17.8766 19.9838 18.178 19.9838ZM17.9086 18.8441L15.6806 16.8552C15.4222 16.6276 15.2588 16.5501 14.9126 16.5501H12.2625C11.0933 16.5501 10.407 15.9287 10.407 14.6905L10.4098 10.4504C10.4098 9.22413 11.0933 8.57885 12.2625 8.57885H19.1333C20.3117 8.57885 20.9889 9.22413 20.9889 10.4504V14.6911C20.9889 15.923 20.3089 16.5501 19.1333 16.5501H18.3957C18.1228 16.5501 17.9086 16.7113 17.9086 17.0623V18.8441Z"
        fill={color}
      />
    </svg>
  );
};

export { ChatsSvg };
